import '../main.less';
import PropTypes from 'prop-types';
import React from 'react';
import ModalBox from '../../../../shared/modal';
import { Field, reduxForm } from 'redux-form';

import SelectField from '../../../../shared/form-elements/select/field';
import CurrencyExchange from './forms-parts/currencyExchange';
import TransferBetweenAffiliates from './forms-parts/transferBetweenAffiliates';
import TransferMoney from './forms-parts/transferMoney';
import CompensateMoney from './forms-parts/compensateMoney';
import PointsExchange from './forms-parts/pointsExchange';

const Form = props => {
	const { selectOptions, disabledFields } = props.transactionFormData;
	const { transactionFormType } = props;
	const submit = data => props.transactionFormSubmit(data, transactionFormType).then(
		props.form === 'affiliateProfileTransactionForm' && (() => props.fetchData(props))
	);

	const shouldDisabled = prepareDisabledFields(disabledFields);

	return (
		<div className="payouts-transaction-form-wrap payouts-form-in-modal">
			<form className="ui-form payouts-form__main clearfix" onSubmit={props.handleSubmit(submit)}>
				<div className="ui-form__element currencies">
					<Field
						name="action"
						placeholder={props.intl('Action')}
						component={SelectField}
						searchable={false}
						multi={false}
						onChange={act => props.changeFormType(act)}
						options={selectOptions['actions']}
					/>
				</div>
				{
					transactionFormType === 'transfer_money'
					&& <TransferMoney {...props} selectOptions={selectOptions} shouldDisabled={shouldDisabled} />
				}
				{
					transactionFormType === 'transfer_money_between_affiliates'
					&& <TransferBetweenAffiliates {...props} selectOptions={selectOptions} shouldDisabled={shouldDisabled} />
				}
				{
					transactionFormType === 'currency_exchange'
					&& <CurrencyExchange {...props} selectOptions={selectOptions} shouldDisabled={shouldDisabled} />
				}
				{
					['transfer_prize_money', 'transfer_adjustment_money', 'transfer_hidden_money']
						.includes(transactionFormType)
					&& <CompensateMoney {...props} selectOptions={selectOptions} shouldDisabled={shouldDisabled} />
				}
				{
					transactionFormType === 'points_exchange'
					&& <PointsExchange {...props} selectOptions={selectOptions} shouldDisabled={shouldDisabled} />
				}

				{	transactionFormType &&
					<button type="submit" className="ui-btn ui-btn-primary apply">
						{props.intl('Apply')}
					</button>
				}
				<button
					className="ui-btn ui-btn-cancel cancel"
					onClick={e => {
						e.preventDefault();
						props.toggleTransactionForm();
					}}
				>
					{props.intl('Cancel')}
				</button>
			</form>
		</div>
	);
};

Form.propTypes = {
	transactionFormData: PropTypes.object,
	handleSubmit: PropTypes.func,
	transactionFormSubmit: PropTypes.func,
	affiliatesLookups: PropTypes.func,
	transactionFormGetAffiliateSettings: PropTypes.func,
	toggleTransactionForm: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func,
	form: PropTypes.string
};

const prepareDisabledFields = disabledFields => fieldName => disabledFields.indexOf(fieldName) > -1;

const Main = props =>
	<ModalBox
		title={props.intl('Transfer money')}
		body={Form(props)}
		isOpen={props.transactionShouldShowStatus}
		onClose={props.toggleTransactionForm}
		className="form-modal affiliate-transactions-modal"
	/>;

Main.propTypes = {
	transactionFormData: PropTypes.object,
	toggleTransactionForm: PropTypes.func,
	transactionShouldShowStatus: PropTypes.bool,
	intl: PropTypes.func
};

export default formName => reduxForm({ form: formName })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/forms/transaction/main.js